import { PageContainer } from '@components'
import { Certification } from '@views/Certification'
import { useParams } from 'react-router'
import { useEffect } from 'react'
import { store } from '@store'

const CertificationPage = () => {
  const { id } = useParams()

  const questionsRespondentFiltered = store.use.questionsRespondentFiltered()
  const getQuestionsRespondentAction = store.use.getQuestionsRespondentAction().call
  const isLoadingGetQuestionsRespondentAction =
    store.use.getQuestionsRespondentAction().status === 'LOADING'

  useEffect(() => {
    getQuestionsRespondentAction({
      model: { idCertificationUserTest: id },
    })
  }, [id])

  return (
    <PageContainer>
      <Certification
        questionsRespondentFiltered={questionsRespondentFiltered}
        isLoading={isLoadingGetQuestionsRespondentAction}
      />
    </PageContainer>
  )
}
export default CertificationPage
